import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import UnivReqComp from '../UnivReqComp';
import { assetInboxTags } from './assetInboxTags';
import useAuth from '../../../../features/hooks/useAuth';


function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function InboxTable({ subTabValue, handleEditclick }) {
  const Auth = useAuth();
  const [limit, setLimit] = useState(5);
  const [lastId, setLastId] = useState(null);
  const [filterProps, setFilterProps] = useState({}); 

  useEffect(() => {
    if (!Auth?.id) return;
  
    let updatedFilterProps = {};
    let sento_tags_filter = assetInboxTags[subTabValue];    


    // Check if subTabValue is EXACTLY 4, not just truthy comparison
    if(Number(subTabValue) === 5) {
      // For closed tab, use perm_flow_users instead of perm_curr_sent_to
      updatedFilterProps = {
        perm_flow_users: [Auth.id],
        perm_curr_sent_to_tag: sento_tags_filter?.length ? sento_tags_filter : ["Not Applicable"],
      };
    } else {
      updatedFilterProps = {
        perm_curr_sent_to: [Auth.id],
        perm_curr_sent_to_tag: sento_tags_filter?.length ? sento_tags_filter : ["Not Applicable"],
      };
    }
  
    setFilterProps(updatedFilterProps);

  }, [Auth?.id, subTabValue]);
  
  // Debug logging for UnitHead inbox issue
  console.log('InboxTable Debug:', {
    subTabValue,
    authId: Auth?.id,
    filterProps,
    expectedTags: assetInboxTags[subTabValue],
    isUnitHeadTab: subTabValue === 2
  });
  const keyArrayDwld = [
    "category", "name", "oem_tag", "org_tag", "oem", "alloc_user", "alloc_ofc", 
    "specification", "pur_store", "in_transit", "cur_store", "cur_loc_name", 
    "purchase_date", "installation_date", "warrantyexp_date", "unit_price", 
    "last_trans_date"
  ];

  const columnFilter = [
    "UniqueReqId", "Req_Type", "Req_Creator", "Store", "Curr_Status", "Created_At",
    "Currently_With", "Status", "Action"
  ];

  return (
    <>
      <UnivReqComp
        filterProps={filterProps}  
        columnFilter={columnFilter}
        handleEditclick={handleEditclick}
        limit={limit} 
        setLimit={setLimit} 
        lastId={lastId} 
        setLastId={setLastId}
        viewType="inbox"
      />    
    </>
  );
}
